export const LOGIN = '[Auth] LOGIN';
export const SET_AD_USER = '[Auth] SET AD USER';
export const LOGIN_SUCCESS = '[Auth] LOGIN SUCCESS';
export const LOGIN_FAILED = '[Auth] LOGIN FAILED';
export const LOGOUT = '[Auth] LOGOUT';
export const LOGOUT_SUCCESS = '[Auth] LOGOUT SUCCESS';
export const EXTEND_LOGOUT_TIMER = '[Auth] EXTEND LOGOUT TIMER';
export const SHOW_LOGOUT_TIMER_DIALOG = '[Auth] SHOW LOGOUT TIMER DIALOG';
export const SESSION_UPDATED = '[Auth] SESSION UPDATED';
export const SET_USER_TYPE = '[Auth] SET USER TYPE';
export const SET_AUTH_TYPE = '[Auth] SET AUTH TYPE';
export const SET_IS_AUTHENTICATED = '[Auth] SET IS AUTHENTICATED';
export const SET_AUTHENTICATION_STARTED = '[Auth] SET AUTHENTICATION STARTED';
export const SET_AUTHENTICATION_ENDED = '[Auth] SET AUTHENTICATION ENDED';
export const SET_OKTA_USERCLAIM = '[Auth] SET OKTA USERCLAIM';
export class Login {
    constructor(payload = null) {
        this.payload = payload;
        this.type = LOGIN;
    }
}
export class SetAdUser {
    constructor(payload = null) {
        this.payload = payload;
        this.type = SET_AD_USER;
    }
}
export class LoginSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGIN_SUCCESS;
    }
}
export class LoginFailed {
    constructor(payload = null) {
        this.payload = payload;
        this.type = LOGIN_FAILED;
    }
}
export class Logout {
    constructor(payload) {
        this.payload = payload;
        this.type = LOGOUT;
    }
}
export class LogoutSuccess {
    constructor(payload = null) {
        this.payload = payload;
        this.type = LOGOUT_SUCCESS;
    }
}
export class ExtendLogoutTimer {
    constructor() {
        this.type = EXTEND_LOGOUT_TIMER;
    }
}
export class SessionUpdated {
    constructor() {
        this.type = SESSION_UPDATED;
    }
}
export class ShowLogoutTimerDialog {
    constructor() {
        this.type = SHOW_LOGOUT_TIMER_DIALOG;
    }
}
export class SetUserType {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_USER_TYPE;
    }
}
export class SetAuthenticationStrategy {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_AUTH_TYPE;
    }
}
export class SetIsAuthenticated {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_IS_AUTHENTICATED;
    }
}
export class SetAuthenticationStarted {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_AUTHENTICATION_STARTED;
    }
}
export class SetAuthenticationEnded {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_AUTHENTICATION_ENDED;
    }
}
export class SetOktaUserclaim {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_OKTA_USERCLAIM;
    }
}
//# sourceMappingURL=auth.actions.js.map